import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const useAuth = () => {
    const accessToken = useSelector((state) => state.user.accessToken);
    const user = useSelector((state) => state.user.user);

    return {
        isAuthenticated: !!accessToken,
        roleId: user?.roleDetails?.id,
    };
};

export const RoleProtectedRoutes = ({ allowedRoles }) => {
    const { isAuthenticated, roleId } = useAuth();
    const location = useLocation();
    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (!allowedRoles.includes(roleId)) {
        return <Navigate to="/unauthorized" state={{ from: location }} replace />;
    }

    return <Outlet />;
};

export const PublicRoutes = () => {
    const accessToken = useSelector((state) => state.user?.accessToken);
    const roleId = useSelector((state) => state.user?.user?.roleDetails?.id);
    const location = useLocation();
  
    if (!accessToken) {
      if (location.pathname !== "/login" && location.pathname !== "/otp") {
        return <Navigate to="/login" state={{ from: location }} replace />;
      }
      return <Outlet />;
    }
  
    if (roleId === null) {
      return <Navigate to="/login" state={{ from: location }} replace />;
    }
  
    const redirectPath =
      roleId === 1 ? "/Sadmin/dashboard" :
      roleId === 4 ? "/Padmin/dashboard" :
      roleId === 2 ? "/pharmacist/dashboard" :
      "/unauthorized";
  
    return <Navigate to={redirectPath} state={{ from: location }} replace />;
  };
  

